/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { OrganizationFromJSON, OrganizationToJSON } from './Organization';
export function GetOrganizationResponseDataFromJSON(json) {
    return GetOrganizationResponseDataFromJSONTyped(json, false);
}
export function GetOrganizationResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        organization: !exists(json, 'organization') ? undefined : OrganizationFromJSON(json['organization'])
    };
}
export function GetOrganizationResponseDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        organization: OrganizationToJSON(value.organization)
    };
}
